/* eslint-disable react/jsx-no-duplicate-props */
import React, { useState } from "react";
import { Modal, Row, Col, Button } from "react-bootstrap";
import CloseIcon from "../../images/close-icon.png";
import odr1 from "../../images/popup/order/odr1.png";
import odr2 from "../../images/popup/order/odr2.png";
import odr3 from "../../images/popup/order/odr3.png";
import odr4 from "../../images/popup/order/odr4.png";
import odr5 from "../../images/popup/order/odr5.png";
import odr6 from "../../images/popup/order/odr6.png";
import odr7 from "../../images/popup/order/odr7.png";
import odr8 from "../../images/popup/order/odr8.png";
import odr9 from "../../images/popup/order/odr9.png";
import odr10 from "../../images/popup/order/odr10.png";
import odr11 from "../../images/popup/order/odr11.png";
import odr12 from "../../images/popup/order/odr12.png";
import odr13 from "../../images/popup/order/odr13.png";
import odr14 from "../../images/popup/order/odr14.png";
import odr15 from "../../images/popup/order/odr15.png";
import odr16 from "../../images/popup/order/odr16.png";
function StorefrontModal() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <div className="more-container">
        <a className="btun" onClick={handleShow}>
          LEARN MORE
        </a>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        centered
        className="AI-modal odrdash"
      >
        <Modal.Body>
          <Button className="close-btn" onClick={handleClose}>
            <img src={CloseIcon} />
          </Button>
          <Row>
            <Col lg="6" sm="12">
              <div className="item">
                <img src={odr1} />
                <p>
                  Onboarding automation <br />
                  <span style={{ color: "#5a00ca" }}>[live in 24 hours]</span>
                </p>
              </div>
              <div className="item">
                <img src={odr2} />
                <p>
                  Payment processing <br />
                  <span style={{ color: "#5a00ca" }}>[Stripe+]</span>
                </p>
              </div>
              <div className="item">
                <img src={odr3} />
                <p>
                  POS and Kitchen Printer integrations <br />
                  <span style={{ color: "#5a00ca" }}>[Toast, Square+]</span>
                </p>
              </div>
              <div className="item">
                <img src={odr4} />
                <p>
                  Delivery dispatch and logic <br />
                  <span style={{ color: "#5a00ca" }}>
                    [zone, distance, terms]
                  </span>
                </p>
              </div>
              <div className="item">
                <img src={odr5} />
                <p>
                  Last-mile delivery service provider integration <br />
                  <span style={{ color: "#5a00ca" }}>
                    [1000+ on-demand drivers]
                  </span>
                </p>
              </div>
              <div className="item">
                <img src={odr6} />
                <p>
                  <span style={{ color: "#5a00ca" }}>[Own]</span> delivery
                  driver management app
                </p>
              </div>
              <div className="item">
                <img src={odr7} />
                <p>
                  Marketplace integrations <br />
                  <span style={{ color: "#5a00ca" }}>
                    [DoorDash, Uber Eats, GrubHub+]
                  </span>
                </p>
              </div>
            </Col>
            <Col lg="6" sm="12">
              <div className="item">
                <img src={odr8} />
                <p>
                  Order consolidation from all channels <br />
                  <span style={{ color: "#5a00ca" }}>
                    [Third-party, Direct, Social+]
                  </span>
                </p>
              </div>
              <div className="item">
                <img src={odr9} />
                <p>
                  Order management <br />
                  <span style={{ color: "#5a00ca" }}>
                    [Pause, 86 item, Notifications+]
                  </span>
                </p>
              </div>
              <div className="item">
                <img src={odr10} />
                <p>Kitchen settings automation</p>
              </div>
              <div className="item">
                <img src={odr11} />
                <p>AI order status automation</p>
              </div>
              <div className="item">
                <img src={odr12} />
                <p>Order history and delivery tracking</p>
              </div>
              <div className="item">
                <img src={odr13} />
                <p>Refund and dispute management</p>
              </div>
              <div className="item">
                <img src={odr14} />
                <p>Financial reports and data analytics</p>
              </div>

              <div className="item">
                <img src={odr15} />
                <p>Price adjustment per channel</p>
              </div>
              <div className="item">
                <img src={odr16} />
                <p>
                  Menu maintenance and monitoring <br />
                  <span style={{ color: "#5a00ca" }}>[AI support]</span>
                </p>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default StorefrontModal;
